export const Contactusbanner = () => {
    return (
        <div className="servicecenter">
	 <div className="container">
	 	<div className="row">
	 		<div className="col-md-12">

              <div className="servicelocaiton">
                <h2>Contact Us:</h2>
                <p>When you need reliable RO repair services in Muzaffarpur, whether it's for routine maintenance or emergency repairs, Aryan Enterprises is here to help. Reach out to us at <a href="tel:8271463038 ">+91-8271463038 </a> or visit our website to schedule an appointment. We're dedicated to ensuring your family or business has access to clean, safe drinking water every day.</p>

				<p>Ensure the health and safety of your loved ones with our expert services. Call us anytime at <a href="tel:8271463038 ">+91-8271463038 </a> for prompt and reliable RO repair assistance.</p>
                {/* <h4>Email Us:</h4>
                <p>waterpurifierservices.info@gmail.com <a href="mailto: waterpurifierservices.info@gmail.com "></a></p> */}
              </div>
	 		</div>
	 	
	 	 
	 </div>
    </div>
</div>
    )
}